import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import defaultObjEquals from '_legacy/components/grid/columnDefaults/defaultObjEquals';
import defaultSetFilterParams from '_legacy/components/grid/columnDefaults/defaultSetFilterParams';
import naturalSortComparator from '_legacy/components/grid/comparators/NaturalSortComparator';
import BlanksFilterRenderer from '_legacy/components/grid/renderers/BlanksFilterRenderer';

export const vesselBuiltDateHeading = {
    colId: 'builtDate',
    headerName: 'Built Date',
    field: 'vessel.builtDate',
    editable: false,
    comparator: naturalSortComparator,
    equals: defaultObjEquals,
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    hide: true,
    filter: 'builtDateFilter',
    width: 100,
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
};
